// extracted by mini-css-extract-plugin
export default {"boxes":"products_boxes__dakh8","checkbox":"products_checkbox__RawRn"};